'use strict';

//var awsIot = require('aws-iot-device-sdk');

import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import EventClass from 'event-class-es6';

Vue.use(Vuex);
const store = new Vuex.Store({
    state: { objUser: null },
    mutations: {
        login(state, payload) {
            state.objUser = payload;
        },
        logout(state) {
            state.objUser = null;
        },
    },
    plugins: [
        new VuexPersistence({
            key: 'user',
            storage: window.localStorage,
            modules: ['objUser'],
        }).plugin,
    ],
});

class Session extends EventClass {
    // get objUser() {
    //     return store.state.objUser;
    // }

    getUser() {
        return store.state.objUser;
    }

    login(user) {
        store.commit('login', user);
        this.emit('update:user');
        this.emit('login');
    }

    setUpdateUser(user) {
        store.commit('login', { ...store.state.objUser, ...user });
        this.emit('update:user');
    }

    logout() {
        store.commit('logout');
        this.emit('update:user');
        this.emit('logout');
    }

    isLoged() {
        return store.state.objUser !== null && store.state.objUser !== undefined;
    }

    isVerified() {
        return this.isLoged() && store.state.objUser.is_verified;
    }

    getClientId() {
        return store.state.objUser ? store.state.objUser.aws_mqtt_user : '';
    }

    getLang() {
        return this.isLoged() ? store.state.objUser.lang : null;
    }

    getMetric() {
        return this.isLoged() ? store.state.objUser.temp : 'C';
    }

    setTokens(user) {
        store.commit('login', { ...store.state.objUser, ...user });
        this.emit('update:user');
        this.emit('setTokens');
    }

    getAccessToken() {
        return store.state.objUser.access_token;
    }

    getRefreshToken() {
        return store.state.objUser.refresh_token;
    }

    getExpirationTime() {
        return store.state.objUser.expires_at * 1000 - new Date().getTime();
    }

    setAwsCredential(user) {
        store.commit('login', { ...store.state.objUser, ...user });
        this.emit('update:user');
        this.emit('setAwsCredential');
    }

    getAwsCredential() {
        return {
            host: store.state.objUser.aws_mqtt_host,
            basePath: store.state.objUser.aws_base_topic,
            accessKeyId: store.state.objUser.aws_access_key_id,
            secretKey: store.state.objUser.aws_secret_access_key,
            sessionToken: store.state.objUser.aws_security_token,
            clientId: store.state.objUser.aws_mqtt_user,
        };
    }

    getMqttExpirationTime() {
        return store.state.objUser.aws_expires_at * 1000 - new Date().getTime();
    }
}

export default Session;
